import { render, staticRenderFns } from "./WebshopCartHeader.vue?vue&type=template&id=455f60cc&scoped=true&"
import script from "./WebshopCartHeader.vue?vue&type=script&lang=js&"
export * from "./WebshopCartHeader.vue?vue&type=script&lang=js&"
import style0 from "./WebshopCartHeader.vue?vue&type=style&index=0&id=455f60cc&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "455f60cc",
  null
  
)

export default component.exports